import React from 'react';

const Reload = () => {
    return (
        <>
            <div className='container' >
                <p className='description centrar'><img src='https://www.wisecrop.com/public/uploads/images/0afd71b2b5724fe7037d5b712c048378.gif' alt="icon" /></p>
            </div>
        </>
    );
}

export default Reload;
